import React from "react";
import { useTranslation } from "react-i18next";
import {
  readyData,
  calculateMuscleGroupsColors,
} from "../../../../utils/workout-stats";
import MuscleBodyLight from "./MuscleBodyLight";
import { useRillContext } from "../../../../rill/RillReact/share/base";

const selectExerciseList = (locals) =>
  locals.currentYearExercises || locals.activeExercises || [];
const selectCurrentDateExercises = (locals) => locals.activeExercises || [];

const MuscleDiagramCard = (props) => {
  const { t } = useTranslation("dashboard");
  const { locals } = useRillContext();

  const { isComposition } = props;
  // muscle diagram data
  const muscleGroupsIntensity = readyData({
    exerciseList: selectExerciseList(locals),
    date: locals.query.date,
    activeExercises: selectCurrentDateExercises(locals),
    isComposition,
  });
  const muscleGroupsColors = calculateMuscleGroupsColors(muscleGroupsIntensity);

  const config = {
    backcolor: muscleGroupsColors.Back,
    glutescolor: muscleGroupsColors.Glutes,
    abductorscolor: muscleGroupsColors.Abductors,
    adductorscolor: muscleGroupsColors.Adductors,
    calvescolor: muscleGroupsColors.Calves,
    // "Legs" is folded into Quadriceps + Hamstrings upstream (foldLegsIntoLegRegions),
    // so it never arrives as its own key here.
    quadricepscolor: muscleGroupsColors.Quadriceps,
    hamstringscolor: muscleGroupsColors.Hamstrings,
    forearmscolor: muscleGroupsColors.Forearms,
    tricepscolor: muscleGroupsColors.Triceps,
    bicepscolor: muscleGroupsColors.Biceps,
    abscolor: muscleGroupsColors.Abs,
    chestcolor: muscleGroupsColors.Chest,
    shoulderscolor: muscleGroupsColors.Shoulders,
  };
  const chooseWrapper = (isComposition) =>
    isComposition ? "composition-content-wrapper" : "content-wrapper";
  const changeLegendOrder = (isComposition) =>
    isComposition && {
      display: "flex",
      maxWidth: "245px",
      justifyContent: "space-between",
      margin: "auto",
    };
  const renderTitle = (isComposition) =>
    !isComposition && <p className="s1 mb-4">{t("calendar.muscleDiagram.workloadByMuscleGroup")}</p>;
  const targetStyle = { width: "100%", aspectRatio: 100 / 92.669 };
  return (
    <div className="card muscle-diagram">
      {renderTitle(isComposition)}
      <div className={chooseWrapper(isComposition)}>
        <div style={targetStyle}>
          <MuscleBodyLight {...config} />
        </div>
        <div
          className="intensity-legend"
          style={changeLegendOrder(isComposition)}
        >
          <div className="max">{t("calendar.muscleDiagram.max")}</div>
          <div className="heavy">{t("calendar.muscleDiagram.heavy")}</div>
          <div className="medium">{t("calendar.muscleDiagram.medium")}</div>
        </div>
      </div>
    </div>
  );
};

export default MuscleDiagramCard;
